// extracted by mini-css-extract-plugin
export default {"socialNameContainer":"Modal_socialNameContainer__Br2B8","modal":"Modal_modal__92NIS"};